var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: none;\r\n        stroke: #f07e25;\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #f07e25;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11269",
    "data-name": "Group 11269",
    transform: "translate(-684.5 -538.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9616",
    "data-name": "Group 9616",
    transform: "translate(685 545.481)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1851",
    "data-name": "Path 1851",
    className: "cls-1",
    d: "M114.331,79.91H119.8",
    transform: "translate(-103.8 -78.394)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1802",
    "data-name": "Ellipse 1802",
    className: "cls-2",
    cx: 1.519,
    cy: 1.519,
    r: 1.519,
    transform: "translate(6.481)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7074",
    "data-name": "Path 7074",
    className: "cls-1",
    d: "M114.331,79.91H119.8",
    transform: "translate(-114.331 -78.394)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9617",
    "data-name": "Group 9617",
    transform: "translate(693.003 539) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1851-2",
    "data-name": "Path 1851",
    className: "cls-1",
    d: "M0,0H5.468",
    transform: "translate(10.532 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7074-2",
    "data-name": "Path 7074",
    className: "cls-1",
    d: "M0,0H5.468",
    transform: "translate(0 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusModal);
export default __webpack_public_path__ + "static/media/PlusModal.9f77fb8ef9cd3dfea4077c7e8ee27fa8.svg";
export { ForwardRef as ReactComponent };